
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
    
    // Send 404 status to the browser for proper error handling
    document.title = "404 - Page Not Found | GridBot & DeFi Academy";
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black text-white">
      <div className="text-center max-w-md p-6 bg-gray-900/60 backdrop-blur-md rounded-lg border border-gray-800 shadow-lg">
        <AlertCircle className="h-16 w-16 text-[#FF3366] mx-auto mb-4" />
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-xl text-gray-300 mb-6">This page doesn't exist or has been moved</p>
        <p className="text-gray-400 mb-6">
          The link you followed may be broken, or the page may have been removed.
        </p>
        <Link to="/">
          <Button className="bg-[#FF3366] hover:bg-[#E62E5C] text-white px-6 py-2">
            Return to Home
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
